import { OrdersSection } from "src/apps/components/ordersSection/OrdersSection";
import { ModelsContent } from "./ModelsContent";
import { OrderModel } from "src/contexts/documentationArea/domain/OrderModel";
import { useIsMedia } from "src/apps/hooks/useIsMedia";

interface ModelsProps {
  models: OrderModel[];
}

const ACCORDION_HEADER_MODELS_HEADER = "documentation_area.models.section_header";
const ACCORDION_HEADER_MODELS_DESCRIPTION = "documentation_area.models.section_description";
const ACCORDION_HEADER_MODELS_DESCRIPTION_MOBILE =
  "documentation_area.models.section_description.mobile";

export const Models = ({ models }: ModelsProps) => {
  const allOrdersCompleted = models.every((model) => model.hasValidResponses());
  const { isDesktop } = useIsMedia();

  if (!models.length) return null;

  return (
    <OrdersSection
      title={ACCORDION_HEADER_MODELS_HEADER}
      description={
        isDesktop ? ACCORDION_HEADER_MODELS_DESCRIPTION : ACCORDION_HEADER_MODELS_DESCRIPTION_MOBILE
      }
      content={<ModelsContent models={models} />}
      isCompleted={allOrdersCompleted}
    />
  );
};
